import { cn } from '@/lib/utils';

const Loader = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn('h-dvh bg-bgPrimary w-full flex items-center justify-center', className)}
      data-testid='loader'
    >
      <div className='flex flex-col justify-center items-center'>
        <div className='loaderAnimation'></div>
      </div>
    </div>
  );
};

export default Loader;
